import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const ACTIONS_OPENED = 'moreButton/ACTIONS_OPENED';

export const actionsOpened = createAction(ACTIONS_OPENED);
